import { render, staticRenderFns } from "./JoinTeam.vue?vue&type=template&id=0fa1e671&scoped=true"
import script from "./JoinTeam.vue?vue&type=script&lang=js"
export * from "./JoinTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa1e671",
  null
  
)

export default component.exports